module.exports = __webpack_public_path__ + "media/flags/je-939d0715.svg";